import get from 'lodash-es/get'
import * as React from 'react'
import { Link } from 'react-router-dom'

import { IItem } from '../../../../typings/searchResults'
import StarRating from '../../../shared/components/starRating'
import AudioPreviewer from './audioPreviewer'
import ItemActions from './common/itemActions'

import * as styles from './gridAudio.module.css'

const ItemCardGridAudio = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {}
}: {
  item: IItem
  onAddToFavourites: () => void
  rank: number
  onAddToCollections: () => void
  onItemLinkClick: () => void
  onAddToCart: () => void
}) => {
  const salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales'

  return (
    <div className={styles.itemView}>
      <div className={styles.actionContainer}>
        <AudioPreviewer
          imageUrl={item.ui.smallPreviewUrl}
          audioUrl={get(item, 'previews.icon_with_audio_preview.mp3_url')}
          url={item.url}
          isTrending={item.trending}
          name={item.name}
          onClick={onItemLinkClick}
          rank={0}
        />
        <ItemActions
          item={item}
          onAddToFavourites={onAddToFavourites}
          onAddToCollections={onAddToCollections}
          onAddToCart={onAddToCart}
        />
      </div>

      <h3 className={styles.itemName}>
        <a
          className="fds-c-text-link -color-inherit -decoration-reversed"
          href={`${item.url}?s_rank=${rank}`}
          onClick={onItemLinkClick}
        >
          {item.name}
        </a>
      </h3>

      <div>
        {!!item.rating.rating && (
          <StarRating
            rating={item.rating.rating}
            className="star-rating--search"
          />
        )}
      </div>

      <footer className={styles.footer}>
        <p className="fds-c-text-body -size-xs fds-u-m0">
          {item.number_of_sales} {salesLabel}{' '}
          <span className="product-grid__price">${item.ui.price}</span>
        </p>
        {item.ui.footerLink && (
          <Link to={item.ui.footerLink.href}>{item.ui.footerLink.label}</Link>
        )}
      </footer>
    </div>
  )
}

export default ItemCardGridAudio
